import { render, staticRenderFns } from "./orderTend-contract.vue?vue&type=template&id=0b25a532&scoped=true"
import script from "./orderTend-contract.vue?vue&type=script&lang=js"
export * from "./orderTend-contract.vue?vue&type=script&lang=js"
import style0 from "./orderTend-contract.vue?vue&type=style&index=0&id=0b25a532&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b25a532",
  null
  
)

export default component.exports